import React from 'react';
import PropTypes from 'prop-types';
import AppPreview from '../creator_studio/app_preview';
import { useGetSpaceQuery } from '../../app/smorgAppSyncGraphQLApi';

const AppContentPreview = ({ innerContent, hideBottomNavigation }) => {
  const { data: space } = useGetSpaceQuery();

  const {
    primaryMainColor,
    backgroundStyle,
    backgroundColor,
    backgroundGradientColor,
  } = space?.whiteLabelElements || {};

  return (
    <AppPreview
      primaryMainColor={primaryMainColor}
      backgroundStyle={backgroundStyle}
      backgroundColor={backgroundColor}
      backgroundGradientColor={backgroundGradientColor}
      innerContent={innerContent}
      hideBottomNavigation={hideBottomNavigation}
    />
  );
};

AppContentPreview.propTypes = {
  innerContent: PropTypes.element.isRequired,
  hideBottomNavigation: PropTypes.bool,
};

AppContentPreview.defaultProps = {
  hideBottomNavigation: false,
};

export default AppContentPreview;
